export enum PriceStripSubCategory {
  arenh = 'arenh',
  balancing = 'balancing',
  cee = 'cee',
  ceeClassique = 'cee_classique',
  ceePreca = 'cee_preca',
  commoSq = 'commo_sq',
  consumption = 'consumption',
  crm = 'crm',
  externalPhysicalBlock = 'external_physical_block',
  injectionExternalPhisycalBlock = 'injection_external_physical_block',
  fixedPower = 'fixed_power',
  goo = 'goo',
  gooCallOption = 'goo_call_option',
  gooPpa = 'goo_ppa',
  gridLosses = 'grid_losses',
  injection = 'injection',
  injectionInternalPhisycalBlock = 'injection_internal_physical_block',
  internalPhysicalBlock = 'internal_physical_block',
  managementFee = 'management_fee',
  powerTerm = 'power_term',
  riskManagementFee = 'risk_management_fee',
  shippingFee = 'shipping_fee',
  soutiragePhysique = 'soutirage_physique',
  transportCost = 'transport_cost',
}
